<template>
  <div class="compound public-content">
    <div class="breadcrumb">显示尺寸管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 0 ">显示尺寸名称:</span>
        <el-input v-model="searchComposeSizeVo.sizeName" placeholder="请输入显示尺寸名称" clearable></el-input>
        <!-- <span style="margin:0 10px 0 20px ">页面类型:</span>
        <el-select v-model="searchComposeSizeVo.pageTypeCode" clearable placeholder="请选择">
          <el-option label="" value="">全部</el-option>
          <el-option v-for="item in $store.state.pms.pageTypeList" :key="item.id" :label="item.typeName" :value="item.typeCode"></el-option>
        </el-select>
        <span style="margin:0 10px 0 20px ">页面名称:</span>
        <el-input v-model="searchComposeSizeVo.pageName" clearable placeholder="请输入页面名称"></el-input> -->
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
        <!-- <el-button round type="primary" @click="pageManage()">页面管理</el-button> -->
        <el-button round type="primary" v-permission="'pts:admin:compose:size:add'" @click="newBuilt()">新建显示尺寸 </el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="显示尺寸名称" min-width="100px" prop="sizeName"></el-table-column>
          <el-table-column label="宽高" min-width="100px">
            <template slot-scope="scope"> 宽度：{{ scope.row.sizeWidth }}mm<br> 高度：{{ scope.row.sizeHeight }}mm </template>
          </el-table-column>
          <el-table-column label="位置" min-width="150px">
            <template slot-scope="scope"> 距上：{{ scope.row.topParam }}mm <br> 距左：{{ scope.row.leftParam }}mm </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100px">
            <template slot-scope="scope">
              <span class="color-blue" v-permission="'pts:admin:compose:size:detail'" @click="check(scope.row)">查看</span><br>
              <span class="color-blue" v-permission="'pts:admin:compose:size:detail'" @click="edit(scope.row)">编辑</span><br>
              <span v-permission="'pts:admin:compose:size:delete'" @click="sizeId = scope.row.id, deleteDialog = true" class="color-blue">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该尺寸？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteSizeGo(sizeId)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="操作显示尺寸" @closed='dialogClose' :visible.sync="dialogVisible" width="700px">
      <el-form hide-required-asterisk :model="createComSize" ref="createForm" label-width="130px">
        <el-form-item label="显示尺寸名称:" prop="sizeName">
          <el-input v-model="createComSize.sizeName" maxlength="20" :disabled="dialogDisable"></el-input>
        </el-form-item>
        <el-form-item label="宽高:">
          <el-form-item label="" style="margin:0;float:left" label-width="0" prop="sizeWidth">
            <el-input placeholder="" v-model="createComSize.sizeWidth" style="width:210px" :disabled="dialogDisable">
              <template slot="prepend">宽</template>
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" style="margin:0;float:left" label-width="0" prop="sizeHeight">
            <el-input placeholder="" v-model="createComSize.sizeHeight" style="width:210px" :disabled="dialogDisable">
              <template slot="prepend">高</template>
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="位置:">
          <el-form-item label="" style="margin:0;float:left" label-width="0" prop="topParam">
            <el-input placeholder="" v-model="createComSize.topParam" style="width:210px" :disabled="dialogDisable">
              <template slot="prepend">距上</template>
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" style="margin:0;float:left" label-width="0" prop="leftParam">
            <el-input placeholder="" v-model="createComSize.leftParam" style="width:210px" :disabled="dialogDisable">
              <template slot="prepend">距左</template>
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
        </el-form-item>
        <!-- <el-form-item label="多个位置模板:" prop="manyPositionTemplate">
          <el-switch v-model="createComSize.manyPositionTemplate" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" :disabled="dialogDisable">
          </el-switch>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="!dialogDisable">
        <el-button type="primary" @click="submitSize(sizeId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index'
import { sizeListPage, pageTypeList, deleteSize, showSizeDetail, sizeUpdate, associateAdd } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    return {
      dialogDisable: false,
      dialogVisible: false,
      createComSize: {},
      sizeId: '',
      deleteDialog: false,
      searchComposeSizeVo: {
        sizeName: ''
      },
      composeList: [],
      keywords: '',
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      compoundType: [],
      tableData: []
    }
  },
  created () {
    // if (sessionStorage.getItem('searchFlag') === 'true') {
    //   this.searchComposeSizeVo = JSON.parse(sessionStorage.getItem('queryParams'))
    //   this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
    //   sessionStorage.removeItem('searchFlag')
    // } else {
    //   // 首次进入列表页,清除缓存中的搜索条件
    //   sessionStorage.removeItem('queryParams')
    //   sessionStorage.removeItem('queryInfo')
    // }
    this.getCompose()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    // 页面管理
    pageManage () {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchComposeSizeVo))
      this.$router.push('/pagetypeadmin')
    },
    // 新建尺寸
    newBuilt () {
      this.dialogVisible = true
    },
    // 查看
    check (row) {
      this.sizeId = row.id
      this.dialogVisible = true
      this.dialogDisable = true
      this.getSizeDetail()
    },
    // 编辑
    edit (row) {
      this.sizeId = row.id
      this.dialogVisible = true
      this.getSizeDetail()
    },
    // 详情
    async getSizeDetail () {
      let res = await showSizeDetail(this.sizeId)
      if (res.data.success) {
        this.createComSize = res.data.data
        this.createComSize.manyPositionTemplate = res.data.data.manyPositionTemplate ? 1 : 0
      }
    },
    async submitSize () {
      let { leftParam, sizeHeight, sizeName, sizeWidth, topParam, manyPositionTemplate } = this.createComSize
      if (!sizeName) {
        this.$message.error('请输入名称')
        return
      }
      if (!sizeHeight || !sizeWidth) {
        this.$message.error('请输入宽高')
        return
      }
      let displaySizeVO = {
        leftParam,
        sizeHeight,
        sizeName,
        sizeWidth,
        topParam,
        manyPositionTemplate
      }
      if (this.sizeId) {
        let res = await sizeUpdate({ data: displaySizeVO, categoryId: this.sizeId })
        if (res.data.success) {
          this.$message.success('修改成功')
          this.dialogClose()
          this.onSubmit()
        }
      } else {
        let res = await associateAdd(displaySizeVO)
        if (res.data.success) {
          this.$message.success('添加成功')
          this.dialogClose()
          this.onSubmit()
        }
      }
    },
    onSubmit () {
      this.getCompose()
    },
    // 列表
    getCompose () {
      sizeListPage({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, data: this.searchComposeSizeVo }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getCompose(this.queryInfo)
          }
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
        }
      })
    },
    changeCompound (url) {
      this.$router.push(url)
    },
    deleteSizeGo (id) {
      deleteSize(id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getCompose(this.queryInfo)
    },
    dialogClose (val) {
      this.dialogVisible = false
      this.dialogDisable = false
      this.sizeId = ''
      this.createComSize = {}
    }
  }
}
</script>
<style scoped lang="less">
.compound {
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    .el-input {
      width: 180px;
    }
  }
}
</style>
